import { createActions } from "redux-actions";

export enum FetchExcelUploadActionTypes {
    REQUEST = "FETCH_EXCEL_UPLOAD_REQUEST",
    SUCCESS = "FETCH_EXCEL_UPLOAD_SUCCESS",
    FAILURE = "FETCH_EXCEL_UPLOAD_FAILURE",
    CLEANUP = "FETCH_EXCEL_UPLOAD_CLEANUP",
}

export enum GetWorkOrderBayesianDataActionTypes {
    REQUEST = "GET_WORK_ORDER_BAYESIAN_DATA_REQUEST",
    SUCCESS = "GET_WORK_ORDER_BAYESIAN_DATA_SUCCESS",
    FAILURE = "GET_WORK_ORDER_BAYESIAN_DATA_FAILURE",
    CLEANUP = "GET_WORK_ORDER_BAYESIAN_DATA_CLEANUP",
}


export enum GetPredictExperimentActionTypes {
    REQUEST = "GET_PREDICT_EXPERIMENT_REQUEST",
    SUCCESS = "GET_PREDICT_EXPERIMENT_SUCCESS",
    FAILURE = "GET_PREDICT_EXPERIMENT_FAILURE",
    CLEANUP = "GET_PREDICT_EXPERIMENT_CLEANUP",
}

export enum GetPropertiesExtrapolationTypes {
    REQUEST = "GET_PROPERTIES_EXTRAPOLATION_REQUEST",
    SUCCESS = "GET_PROPERTIES_EXTRAPOLATION_SUCCESS",
    FAILURE = "GET_PROPERTIES_EXTRAPOLATION_FAILURE",
    CLEANUP = "GET_PROPERTIES_EXTRAPOLATION_CLEANUP",
}

export enum GetPredictionHistoryListActionTypes  {
    REQUEST = "GET_PREDICTION_HISTORY_LIST_REQUEST",
    SUCCESS = "GET_PREDICTION_HISTORY_LIST_SUCCESS",
    FAILURE = "GET_PREDICTION_HISTORY_LIST_FAILURE",
    CLEANUP = "GET_PREDICTION_HISTORY_LIST_CLEANUP",
}

export enum GetPredictionHistoryDetailsDataActionTypes  {
    REQUEST = "GET_PREDICTION_HISTORY_DETAILS_DATA_REQUEST",
    SUCCESS = "GET_PREDICTION_HISTORY_DETAILS_DATA_SUCCESS",
    FAILURE = "GET_PREDICTION_HISTORY_DETAILS_DATA_FAILURE",
    CLEANUP = "GET_PREDICTION_HISTORY_DETAILS_DATA_CLEANUP",
}

export enum GetPredictionHistoryDetailFilterActionTypes  {
    REQUEST = "GET_PREDICTION_HISTORY_DETAIL_FILTER_REQUEST",
    SUCCESS = "GET_PREDICTION_HISTORY_DETAIL_FILTER_SUCCESS",
    FAILURE = "GET_PREDICTION_HISTORY_DETAIL_FILTER_FAILURE",
    CLEANUP = "GET_PREDICTION_HISTORY_DETAIL_FILTER_CLEANUP",
}

export enum DeletePredictionHistoryActionTypes {
    REQUEST = "DELETE_PREDICTION_HISTORY_REQUEST",
    SUCCESS = "DELETE_PREDICTION_HISTORY_SUCCESS",
    FAILURE = "DELETE_PREDICTION_HISTORY_FAILURE",
    CLEANUP = "DELETE_PREDICTION_HISTORY_CLEANUP",
}

export enum FetchProjectListFiltersOptionActionTypes {
    REQUEST = "FETCH_PROJECT_LIST_FILTERS_OPTION_REQUEST",
    SUCCESS = "FETCH_PROJECT_LIST_FILTERS_OPTION_SUCCESS",
    FAILURE = "FETCH_PROJECT_LIST_FILTERS_OPTION_FAILURE",
    CLEANUP = "FETCH_PROJECT_LIST_FILTERS_OPTION_CLEANUP"
}

export const {
    getWorkOrderBayesianDataRequest,
    getWorkOrderBayesianDataSuccess,
    getWorkOrderBayesianDataFailure,
    getWorkOrderBayesianDataCleanup,
    getPredictExperimentRequest,
    getPredictExperimentSuccess,
    getPredictExperimentFailure,
    getPredictExperimentCleanup,
    fetchExcelUploadRequest,
    fetchExcelUploadSuccess,
    fetchExcelUploadFailure,
    fetchExcelUploadCleanup,
    getPropertiesExtrapolationRequest,
    getPropertiesExtrapolationSuccess,
    getPropertiesExtrapolationFailure,
    getPropertiesExtrapolationCleanup,
    getPredictionHistoryListRequest,
    getPredictionHistoryListSuccess,
    getPredictionHistoryListFailure,
    getPredictionHistoryListCleanup,
    getPredictionHistoryDetailsDataRequest,
    getPredictionHistoryDetailsDataSuccess,
    getPredictionHistoryDetailsDataFailure,
    getPredictionHistoryDetailsDataCleanup,
    getPredictionHistoryDetailFilterRequest,
    getPredictionHistoryDetailFilterSuccess,
    getPredictionHistoryDetailFilterFailure,
    getPredictionHistoryDetailFilterCleanup,
    deletePredictionHistoryRequest,
    deletePredictionHistorySuccess,
    deletePredictionHistoryFailure,
    deletePredictionHistoryCleanup,
    fetchProjectListFiltersOptionRequest,
    fetchProjectListFiltersOptionSuccess,
    fetchProjectListFiltersOptionFailure,
    fetchProjectListFiltersOptionCleanup
} = createActions({
    [GetWorkOrderBayesianDataActionTypes.REQUEST]: payload => payload,
    [GetWorkOrderBayesianDataActionTypes.SUCCESS]: payload => payload,
    [GetWorkOrderBayesianDataActionTypes.FAILURE]: payload => payload,
    [GetWorkOrderBayesianDataActionTypes.CLEANUP]: () => { },
    [GetPredictExperimentActionTypes.REQUEST]: payload => payload,
    [GetPredictExperimentActionTypes.SUCCESS]: payload => payload,
    [GetPredictExperimentActionTypes.FAILURE]: payload => payload,
    [GetPredictExperimentActionTypes.CLEANUP]: () => { },
    [FetchExcelUploadActionTypes.REQUEST]: payload => payload,
    [FetchExcelUploadActionTypes.SUCCESS]: payload => payload,
    [FetchExcelUploadActionTypes.FAILURE]: payload => payload,
    [FetchExcelUploadActionTypes.CLEANUP]: () => { },
    [GetPropertiesExtrapolationTypes.REQUEST]: payload => payload,
    [GetPropertiesExtrapolationTypes.SUCCESS]: payload => payload,
    [GetPropertiesExtrapolationTypes.FAILURE]: payload => payload,
    [GetPropertiesExtrapolationTypes.CLEANUP]: () => { },
    [GetPredictionHistoryListActionTypes.REQUEST]: payload => payload,
    [GetPredictionHistoryListActionTypes.SUCCESS]: payload => payload,
    [GetPredictionHistoryListActionTypes.FAILURE]: payload => payload,
    [GetPredictionHistoryListActionTypes.CLEANUP]: () => { },
    [GetPredictionHistoryDetailsDataActionTypes.REQUEST]: payload => payload,
    [GetPredictionHistoryDetailsDataActionTypes.SUCCESS]: payload => payload,
    [GetPredictionHistoryDetailsDataActionTypes.FAILURE]: payload => payload,
    [GetPredictionHistoryDetailsDataActionTypes.CLEANUP]: () => { },
    [GetPredictionHistoryDetailFilterActionTypes.REQUEST]: payload => payload,
    [GetPredictionHistoryDetailFilterActionTypes.SUCCESS]: payload => payload,
    [GetPredictionHistoryDetailFilterActionTypes.FAILURE]: payload => payload,
    [GetPredictionHistoryDetailFilterActionTypes.CLEANUP]: () => { },
    [DeletePredictionHistoryActionTypes.REQUEST]: payload => payload,
    [DeletePredictionHistoryActionTypes.SUCCESS]: payload => payload,
    [DeletePredictionHistoryActionTypes.FAILURE]: payload => payload,
    [DeletePredictionHistoryActionTypes.CLEANUP]: () => { },
    [FetchProjectListFiltersOptionActionTypes.REQUEST]: payload => payload,
    [FetchProjectListFiltersOptionActionTypes.SUCCESS]: payload => payload,
    [FetchProjectListFiltersOptionActionTypes.FAILURE]: payload => payload,
    [FetchProjectListFiltersOptionActionTypes.CLEANUP]: () => {}
})